import {useEffect, useState} from 'react';
import { useIntl } from 'react-intl';
import { ProgressSpinner } from 'primereact/progressspinner';

import { useAPIUploadImgToS3, MAX_SIZE_LOGO } from '@marketplace/api';
import { Icon } from '@marketplace/ui-elements';

import classes from './uploader.module.scss';

type TUploaderProps = {
  isContentEditable: boolean;
  setInitialData: React.Dispatch<any>;
  initialData: any;
  setValue: any;
  setError: any;
  clearErrors: any;
  error?: string;
  label?: string;
  icon?: File;
  setIcon: React.Dispatch<any>;
  getValues: any;
  trigger: any;
};

export const Uploader = ({ 
  isContentEditable, 
  initialData, 
  setValue, 
  setError, 
  clearErrors, 
  error,
  icon,
  setIcon,
  getValues,
  trigger,
  label }: TUploaderProps) => {
  
  const { formatMessage } = useIntl();
  const { uploadImgToS3, data, loading } = useAPIUploadImgToS3();

  const handleSelectImage = (event: any) => {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    if(file.type === 'image/png' || file.type ==='image/jpeg' ) {
      if(file.size <= MAX_SIZE_LOGO) {
        uploadImgToS3(file);
        setIcon(file);
        event.target.value = null;
        return;
      }
      setError('logo', {message: formatMessage({id: 'developer_personal_page_info_logo_error'})})
      setValue('logo', '', {shouldDirty: true})
      event.target.value = null;
      setIcon({});
      return;
    }
    setError('logo', {message: formatMessage({id: 'developer_personal_page_type_error'})})
    setValue('logo', '', {shouldDirty: true})
    event.target.value = null;
    setIcon({});
  };

  useEffect(() => {
    setIcon(initialData.logo)
  }, [initialData])

  useEffect(() => {
    clearErrors('logo');
    setValue('logo', data, {shouldDirty: true})
    trigger();
  }, [data]);

  const handleDeleteIcon = () => {
    if(initialData?.logo) {
      setValue('logo', '', {shouldDirty: true})
    }
    if (icon) {
      clearErrors('logo')
      setValue('logo', '')
      setIcon(null)
    }
  }

  return (
    <div className={classes.upload_logo_block}>
      <div className={classes.uploader_label}>Company Logo</div>
      <label
        htmlFor="icon-file"
        className={
          isContentEditable
            ? classes.uploader_wrapper
            : classes.wrapper_not_editable
        }
        style={{
          backgroundImage: `url(${
            icon?.name
              ? URL.createObjectURL(icon)
              : initialData?.logo
          })`,
        }}
      >
        {!icon && isContentEditable && !getValues('logo') && (
          <div className={classes.text_block}>
            <span className={classes.selectImage}>select image</span>
            <span className={classes.formats}>
              {label}
            </span>
          </div>
        )}
        {!icon && !getValues('logo') && (
          <span className={classes.background_img}></span>
        )}
        <input
          className={classes.img_input}
          id="icon-file"
          type="file"
          accept="image/png, image/jpg, image/jpeg"
          name="logo"
          data-testid="icon-file"
          onChange={handleSelectImage}
        />
        {loading && <ProgressSpinner style={{width: '50px', height: '50px'}} />}
      </label>
      {isContentEditable &&
        <div className={classes.close_btn} onClick={handleDeleteIcon} data-testid="delete">
          <Icon glyph={Icon.glyphs.font['pi-times-circle']} />
        </div>
      }
      <span className={classes.error}>
        {error}
      </span> 
    </div>
  );
};
